
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.86 13.547a3.405 3.405 0 01-1.067-1.805 3.932 3.932 0 010-2.105c.164-.684.52-1.285 1.066-1.805l6.153-6.18c.383-.382.82-.629 1.367-.793a3.224 3.224 0 011.613 0 3.533 3.533 0 011.422.82c.383.383.656.848.82 1.395a3.224 3.224 0 010 1.614 3.262 3.262 0 01-.82 1.394l-5.168 5.195c-.437.438-.957.63-1.559.63-.601 0-1.12-.192-1.558-.63a2.13 2.13 0 01-.656-1.558c0-.602.218-1.121.656-1.559L8.53 3.758c.055-.055.11-.082.219-.082a.31.31 0 01.219.082l.465.465c.054.082.109.164.109.246 0 .11-.055.164-.11.218L5.06 9.09a.792.792 0 00-.274.629.79.79 0 00.274.629.867.867 0 00.628.246.867.867 0 00.63-.246l5.195-5.196a1.78 1.78 0 00-.028-2.543 1.78 1.78 0 00-1.285-.546c-.492 0-.93.19-1.285.519L2.762 8.734c-.547.547-.793 1.204-.793 1.97 0 .765.246 1.394.793 1.94.547.547 1.175.793 1.941.793s1.422-.273 1.969-.82l5.332-5.36c.055-.054.137-.081.246-.081a.31.31 0 01.219.082l.465.465c.054.082.109.164.109.246 0 .11-.055.164-.11.218l-5.331 5.36c-.547.547-1.149.902-1.832 1.066a3.932 3.932 0 01-2.106 0 3.405 3.405 0 01-1.805-1.066z"}})])
          )
        }
      }
    